import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a79c552df0b440014e67201_1787425277255_1dec5133/griott/src/app/discover/components/DiscoverPage.tsx");
